// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"Categories_sectionContainer__MrC0P"};